import { FC } from 'react';
import { Button, Col, Form, InputNumber, message, Row, Select, Spin } from "antd";
import * as React from "react";
import restful from '../../restful';
import SelectUsersField from '../fields/select-user-field';

interface Prop { }

const TansactionForm: FC<Prop> = () => {
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false)

	function onFinish(data: any) {
		setLoading(true)
		const url = "/transactions/" + data.action
		delete data.action
		data.unit = "toman"
		restful.request({ data, method: "POST", url })
			.then((res) => {
				form.resetFields()
				message.success("انجام شد")
			})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));
	}

	return (
		<Spin spinning={loading} >
			<Form form={form} onFinish={onFinish} layout="vertical" autoComplete='off'>
				<Row gutter={16}>

					<Col xs={24} md={12}  >
						<Form.Item name="cost" label="مبلغ"
							rules={[{ required: true, message: "این فیلد ضروری است" },]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="user" label="کاربر"
							rules={[{ required: true, message: "این فیلد ضروری است" },]}
						>
							<SelectUsersField />
						</Form.Item>
					</Col>

					<Col xs={24} md={12}  >
						<Form.Item name="action" label="عملیات"
							rules={[{ required: true, message: "این فیلد ضروری است" },]}
						>
							<Select >
								<Select.Option key="cart">کارت به کارت</Select.Option>
								<Select.Option key="withdrawal"> برداشت از حساب </Select.Option>
							</Select>
						</Form.Item>
					</Col>



					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">ثبت</Button>
					</Col>
				</Row>
			</Form>
		</Spin>
	)
}

export default TansactionForm;
